import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Nav = styled.nav`
  margin-left: 2rem;
  display: flex;
  align-items: center;

  @media (max-width: 1400px) {
    display: none;
  }
`;

export const NavItem = styled(Link)`
  color: var(--carbone100);
  text-decoration: none;
  transition: var(--transition);
  white-space: nowrap;
  font-size: 13px;
  margin-right: 1vw;

  &:hover {
    color: var(--theme-palette-links-primary-color-hover);
  }
`;

export const NavCollapsed = styled.div`
  position: relative;
  margin-left: 1.8rem;
  flex-shrink: 0;
  display: none;

  @media (max-width: 1400px) {
    display: block;
  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg & {
      margin-left: 0.5rem;
    }
  }
`;

export const NavToggleArrow = styled.span`
  font-size: 10px;
  transition: transform 0.2s;
`;

export const NavToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: var(--carbone100);
  padding: 5px 4px;
  white-space: nowrap;
  transition: var(--transition);

  &:hover {
    color: var(--theme-palette-links-primary-color-hover);
  }

  &:focus-visible {
    outline: 2px dotted var(--theme-palette-brand-color);
    outline-offset: 2px;
  }

  &[aria-expanded='true'] ${NavToggleArrow} {
    transform: rotate(180deg);
  }
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 1vw;
  color: var(--carbone100);
  transition: var(--transition);

  &:hover {
    color: var(--theme-palette-links-primary-color-hover);
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 160px;
  background: var(--white);
  border: 1px solid var(--aluminium35);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 6px 0;
  z-index: 4;
  display: flex;
  flex-direction: column;

  ${NavItem} {
    margin-right: 0;
    padding: 9px 18px;
    font-size: 14px;

    &:hover {
      background: var(--aluminium10);
    }
  }

  ${NavButton} {
    margin-right: 0;
    padding: 9px 18px;
    font-size: 14px;
    gap: 8px;

    &:hover {
      background: var(--aluminium10);
    }
  }
`;